import { createSlice } from '@reduxjs/toolkit';
import ReducerRegistry from '../../../../base/redux/ReducerRegistry';
const initialState = {
    images: [],
    currentImage: 0,
    isOpen: false,
};
const imagesViewSlide = createSlice({
    name: 'features/images-viewer',
    initialState,
    reducers: {
        setImages: (state, action) => {
            return {
                ...state,
                images: action.payload,
            };
        },
        openImageByIndex: (state, action) => {
            return {
                ...state,
                currentImage: action.payload,
                isOpen: true,
            };
        },
        openImageBySrc: (state, action) => {
            const openImageIndex = state.images.findIndex(image => image.src === action.payload);
            if (openImageIndex >= 0) {
                return {
                    ...state,
                    currentImage: openImageIndex,
                    isOpen: true,
                };
            }
            else {
                return state;
            }
        },
        closeViewer: (state) => {
            return {
                ...state,
                isOpen: false,
            };
        },
        addImages: (state, action) => {
            return {
                ...state,
                images: [...state.images, ...action.payload],
            };
        },
        removeImages: (state, action) => {
            return {
                ...state,
                images: state.images.filter((_, idx) => !action.payload.includes(idx)),
            };
        },
        nextImage: (state) => {
            return {
                ...state,
                currentImage: Math.min(state.images.length - 1, state.currentImage + 1),
            };
        },
        previousImage: (state) => {
            return {
                ...state,
                currentImage: Math.max(0, state.currentImage - 1),
            };
        },
    },
});
ReducerRegistry.register('features/images-viewer', imagesViewSlide.reducer);
export const { setImages, openImageByIndex, openImageBySrc, closeViewer, addImages, removeImages, nextImage, previousImage, } = imagesViewSlide.actions;
export default imagesViewSlide.reducer;
